import Alert from '@mui/material/Alert';
import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type SettingsQueryGateProps<TData> = {
    query: Pick<UseQueryResult<TData>, 'isError' | 'data'>;
    loading: ReactElement;
    children: (data: TData, isStale: boolean) => ReactNode;
};

export function SettingsQueryGate<TData>({ query, loading, children }: SettingsQueryGateProps<TData>): ReactElement {
    const { t } = useTranslation();

    if (query.data !== undefined) {
        // A failed background refetch must not blank a page that already has data - mark it stale instead.
        return (
            <>
                {query.isError && (
                    <Alert severity="warning" sx={{ mb: 2 }}>
                        {t('SETTINGS.ERRORS.REFRESH_SETTINGS')}
                    </Alert>
                )}
                {children(query.data, query.isError)}
            </>
        );
    }

    if (query.isError) {
        return <Alert severity="error">{t('SETTINGS.ERRORS.LOAD_SETTINGS')}</Alert>;
    }

    return loading;
}
